import { render, staticRenderFns } from "./EditAdresses.vue?vue&type=template&id=5a9066df&"
import script from "./EditAdresses.vue?vue&type=script&lang=ts&"
export * from "./EditAdresses.vue?vue&type=script&lang=ts&"
import style0 from "./EditAdresses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports